module.exports = __webpack_public_path__ + "img/4-sdg-border@2x.7bd02ea2.png";